import useFetch from '@hooks/useFetch';

const useAutoCompleteResults = (query) => {
  const key = `v1/search/autocomplete/elaborated/3/?q=${query}`;
  const { data: autoCompleteResults, ...rest } = useFetch(query ? key : null);
  return { autoCompleteResults: query ? autoCompleteResults : [], ...rest };
};

export default useAutoCompleteResults;
